<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('usersmeanspaiementconfirmation.management')}} <span v-if="marchand_name">  : {{marchand_name}}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="basil"
                        grow
                >
                    <v-tab
                            v-for="item in items"
                            :key="item"
                    >
                        {{ item }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                            key="Paiement en attente"
                    >
                        <v-card
                                color="basil"
                                flat
                        >

                            <UserMeansPaimentsConfirmatonEnCours></UserMeansPaimentsConfirmatonEnCours>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item key="Paiement effectués">
                        <v-card color="basil" flat>
                            <UserMeansPaimentsConfirmatonEffectue></UserMeansPaimentsConfirmatonEffectue>
                        </v-card>
                    </v-tab-item>

                </v-tabs-items>
            </v-card>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import UserMeansPaimentsConfirmatonEnCours from "./UserMeansPaimentsConfirmatonEnCours";
    import UserMeansPaimentsConfirmatonEffectue from "./UserMeansPaimentsConfirmatonEffectue";

    export default {
        components: {UserMeansPaimentsConfirmatonEffectue, UserMeansPaimentsConfirmatonEnCours},
        label: "UserMeansPaimentsConfirmaton",
        data() {
            return {
                submitting: false,
                valid: true,
                marchand_name:undefined,
                lazy: false,
                errors: undefined,
                errors_means: null,
                errors_montant: null,
                itemSteps: [
                    "Mois", "Trimestre", "Semestre"
                ],
                tab: null,
                items: [
                     this.$t("usersmeanspaiementconfirmation.tab1"),  this.$t("usersmeanspaiementconfirmation.tab2")
                ],
                search: '',
                dialog: '',
                id: undefined,
                step1: false,
                step2: false,
                step3: false,
                type: 'Mobile',
                user: JSON.parse(localStorage.getItem("user")),
                e1: 1,
                typesLists:['Mobile', 'Banque'],
                typesLists2:['bystep', 'byperiode'],
                headers: [
                    {
                        text: 'Compte de virement',
                        align: 'start',
                        sortable: true,
                        value: '_usermeanspaiement._account_name',
                    },
                    {text: 'Numéro du compte', value: '_usermeanspaiement._account_number'},
                    {text: 'Montant', value: '_montant'},
                    {text: 'Type de transfert', value: '_type_transfert'},
                    {text: 'Période', value: '_periode'},
                    {text: 'Information', value: '_send_mail'},
                    {text: 'Etat', value: '_status'},
                    {text: 'Notre avis', value: '_note'},
                    {text: 'Action', value: 'actions'}
                ],
                editedIndex: -1,
                editedItem: {
                    _type_transfert: 'bystep',
                    _montant: 1,
                    _periode: 'Mois',
                    _send_mail: '',
                    _user: '',
                    _status: '',
                    _note: '',
                    _usermeanspaiement: '',
                    _type_means: 'Mobile',
                    _cancel: false,
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                    _type_transfert: 'bystep',
                    _montant: 1,
                    _periode: 'Mois',
                    _send_mail: '',
                    _user: '',
                    _status: '',
                    _note: '',
                    _usermeanspaiement: '',
                    _type_means: 'Mobile',
                    _cancel: false,
                    _id: 0,
                    _created_at: 0,
                },
                periodeRules: [
                    v => !!v || 'Période requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                type_transfertRules: [
                    v => !!v || 'Type requis',
                ]
                ,
                montantRules: [
                    v => !!v || 'Montant requis',
                ],
                usermeanspaiementRules: [
                    v => !!v || 'Moyen de paiement requis',
                ]

            }
        }
        ,
        computed: {
          ...mapState('settingtransactions/',['settingtransactions','load','themarchand'])

        }
        ,
        mounted() {


            this.marchand_name = undefined;
            if(this.$route.params.id){
              let data = new FormData();
              data.append("id", this.$route.params.id);
              this.$store.dispatch('settingtransactions/getMarchandWithSetting',data).then(response=>{
                  console.log('documents',this.$store.state.settingtransactions)
                 this.marchand_name = this.$store.state.settingtransactions.themarchand._company;
              });
          }

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            setdefault(){
                this.e1 = 1;
                this.step1=false;
                this.step2=false;
                this.step3=false;
                $(".chooseAll").css("background-color", "");
                $(".chooseAllRev").css("background-color", "");
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            },
            chooseItem(item) {
                this.step1 = false;
                this.editedItem._type_means = item;
                $(".chooseAll").css("background-color", "");
                $("#" + item).css("background-color", "#A1C4E8");
                this.validestep(1)
                this.changeType(item)

            }, chooseItemRev(item) {
                this.step2 = false;
                this.editedItem._type_transfert = item;
                $(".chooseAllRev").css("background-color", "");
                $("#" + item).css("background-color", "#A1C4E8");
                this.validestep(2)

            },
            validestep(step){

                switch (step) {
                    case 1:

                        if (this.typesLists.includes(this.editedItem._type_means))
                        {
                            this.step1 = true;
                        }else{
                            this.step1 = false;
                        }
                        break;

                    case 2:
                        if (this.typesLists2.includes(this.editedItem._type_transfert))
                        {
                            this.step2 = true;
                        }else{
                            this.step2 = false;
                        }
                        break;


                    case 3:
                        this.errors_means = null;
                        this.errors_montant = null;
                        if (this.editedItem._type_transfert=="bystep")
                        {
                            if (!isNaN(this.editedItem._montant))
                            {
                                if (parseFloat(this.editedItem._montant)>=10000)
                                {
                                    if(this.editedItem._usermeanspaiement!='')
                                    {
                                        this.step3 = true;
                                    }else{
                                        this.step3 = false;
                                        this.errors_means = this.$t("reversements.errors_means");
                                    }
                                }else{
                                    this.step3 = false;
                                    this.errors_montant = this.$t("reversements.errors_montant2");
                                }
                            }else{
                                this.errors_montant = this.$t("reversements.errors_montant");
                            }

                        }else{
                            if(this.editedItem._usermeanspaiement!='')
                            {
                                this.step3 = true;
                            }else{
                                this.step3 = false;
                                this.errors_means = this.$t("reversements.errors_means");
                            }
                        }

                        break;

                }

            },
            changeType(item) {
                console.log(item)
                let data = new FormData();
                data.append("id", this.$store.getters.auth._id);
                data.append("type", item);
                this.$store
                    .dispatch('user_means_paiements/getUser_means_paiementsBytype', data)
                    .then(response => {
                        window.console.log('user_means_paiements', response)
                    });
            },
            cancelReverse(item) {
                console.log(item);
                let data = new FormData();
                data.append("id", item._id);
                if (item._cancel === false || item._cancel === null) {
                    data.append("cancel", true);
                    console.log("cancel : true");

                } else {
                    data.append("cancel", false);
                    console.log("cancel : false");

                }
                data.append("_user", this.$store.getters.auth._id);
                this.$store.dispatch('reversements/getUpdateCancel', data).then(response => {
                    window.console.log('reversements', response)
                });
            },

            editItem(item) {
                this.editedIndex = this.cities.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem._region_id = item._region_id._id;
                this.dialog = true;

                $("#regions option").each(function () {
                    // Add $(this).val() to your list
                    // console.log($(this).val());
                    if ($(this).val() == item._region_id._id) {
                        console.log($(this).val());
                        $(this).attr("selected", "selected");
                    }
                });
            },
            deleteItem(item) {
                const index = this.cities.indexOf(item);
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('cities/deleteCity', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;

                let data = new FormData();
                if (this.editedItem._type_transfert === "bystep") {
                    data.append("_montant", this.editedItem._montant);
                    data.append("_periode", "---");
                } else {
                    data.append("_montant", "---");
                    data.append("_periode", this.editedItem._periode);
                }
                if (this.editedItem._send_mail === "success") {
                    data.append("_send_mail", this.editedItem._send_mail);
                } else {
                    data.append("_send_mail", "refused");
                }
                data.append("_type_transfert", this.editedItem._type_transfert);
                data.append("_user", this.$store.getters.auth._id);
                data.append("_usermeanspaiement", this.editedItem._usermeanspaiement);
                data.append("_status", "en_attente");
                data.append("_note", "Vide");
                let mineroute = 'reversements/setReversement';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'cities/setUpdateCity';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;
                    console.log('set reversements response', response);
                    if (response.error) {
                        this.errors.operation = response.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            }
            ,
            getColor(calories) {
                if (calories == "bystep") return 'green'
                else if (calories == "byperiode") return 'blue'
                else return 'green'
            },
            getColor2(calories) {
                if (calories == "en_attente") return 'orange'
                else if (calories == "success") return 'green'
                else return 'red'
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
